import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login";
import Signup from "../pages/auth/signup";
import CreatorDashboard from "../pages/creator/dashboard";
import Subscribers from "../pages/creator/subscribers";
import Contents from "../pages/creator/contents";
import CreatorChat from "../pages/creator/chat";
import Tips from "../pages/creator/tips";
import FanDashboard from "../pages/fan/dashboard";
import CreatorDetail from "../pages/fan/creator-detail";
import Wallet from "../pages/fan/wallet";
import Explore from "../pages/fan/explore";
import AdminDashboard from "../pages/admin/dashboard";
import AdminCreators from "../pages/admin/creators";
import AdminFans from "../pages/admin/fans";
import AdminTransactions from "../pages/admin/transactions";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/creator/dashboard",
    element: <CreatorDashboard />,
  },
  {
    path: "/creator/subscribers",
    element: <Subscribers />,
  },
  {
    path: "/creator/contents",
    element: <Contents />,
  },
  {
    path: "/creator/chat",
    element: <CreatorChat />,
  },
  {
    path: "/creator/tips",
    element: <Tips />,
  },
  {
    path: "/fan/dashboard",
    element: <FanDashboard />,
  },
  {
    path: "/fan/creator/:id",
    element: <CreatorDetail />,
  },
  {
    path: "/fan/wallet",
    element: <Wallet />,
  },
  {
    path: "/fan/explore",
    element: <Explore />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/admin/creators",
    element: <AdminCreators />,
  },
  {
    path: "/admin/fans",
    element: <AdminFans />,
  },
  {
    path: "/admin/transactions",
    element: <AdminTransactions />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
